// extracted by mini-css-extract-plugin
export default {"Carriers":"carriers_Carriers__Lxr4N","CarriersContent":"carriers_CarriersContent__LZjYl"};